import axiosInstance from "./axios-instance";
import { ExtractedFabricDetails } from "../components/calculator/fabric-url-prefill";

const FABRIC_EXTRACT_REQUEST_TIMEOUT_MS = 35000;

const extractFabricFromUrl = async (url: string): Promise<ExtractedFabricDetails> => {
    try {
        const response = await axiosInstance.post<ExtractedFabricDetails>("/ai/fabric/extract", {
            url,
        }, {
            timeout: FABRIC_EXTRACT_REQUEST_TIMEOUT_MS,
        });
        const data = response.data as any;
        if (data && data.error) {
            throw new Error(data.message || "Unable to extract fabric details");
        }
        return response.data;
    } catch (error) {
        console.error("Error extracting fabric from URL:", error);
        throw error;
    }
};

export { extractFabricFromUrl };
